import type { FC, ReactNode } from 'react';
import {
  Radio,
  RadioGroup,
  RadioGroupProps,
  RadioProps,
} from '@chakra-ui/react';
import { DataProps } from '../../utils';

export type QRadioProps = Pick<
  RadioProps,
  | 'isDisabled'
  | 'isChecked'
  | 'isInvalid'
  | 'value'
  | 'onClick'
  | 'onChange'
  | 'isReadOnly'
> &
  DataProps & {
    children?: ReactNode;
  };

export const QRadio: FC<QRadioProps> = (props) => {
  return <Radio {...props} size="md" />;
};

export type QRadioGroupProps = RadioGroupProps & {
  children?: ReactNode;
};

export const QRadioGroup: FC<QRadioGroupProps> = (props) => {
  const { children, ...rest } = props;

  return <RadioGroup {...rest}>{children}</RadioGroup>;
};
